import { render, staticRenderFns } from "./CdbCustomerOtherDocumentsList.vue?vue&type=template&id=40b5687b&scoped=true&"
import script from "./CdbCustomerOtherDocumentsList.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerOtherDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerOtherDocumentsList.vue?vue&type=style&index=0&id=40b5687b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b5687b",
  null
  
)

export default component.exports